import { AssetCreatedEvent } from '../event/asset-created.event';
const assetCreatedProjections = {
    [AssetCreatedEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default assetCreatedProjections;
//# sourceMappingURL=asset-created.projection.js.map